/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { displayInline } from '../style.js'
import React from 'react'
import { useOrderTicket, MODES } from '../use-order-ticket.js'
import { getId, fmt, Flyout } from '../../twd'

export const Price = () => {
    const {
        action, price, setPrice, priceOrYield, setPriceOrYield,
        orderInfo, hasOrderInfo, hasBondInfo,
        mode, errors, setPriceEl, isRestricted,
        bestPrice,
    } = useOrderTicket()

    const s = orderInfo.statusMsg || ''
    const hasMarket = s.indexOf('NO OFFERINGS FOR TICKET') < 0
        && s.indexOf('NO ORDER CONFIGURED FOR TICKET') < 0

    const canTrade = hasBondInfo && !isRestricted
    const isLift = mode===MODES.ORDER_Z
    const isDisabled = !canTrade || !hasMarket
    const isCounterDisallowed = canTrade && (orderInfo.countersAllowed === 'N' || orderInfo.primary==='Y')
    const isReadOnly = isLift || isCounterDisallowed

    const id = getId()
    const err = !isDisabled && errors && errors.price
    const priceLabel = action==='B' ? 'Offer' :
        action==='S' ? 'Bid' :
        ''

    return <React.Fragment>
    <div className={isReadOnly ? "" : "row"}>
    {!isReadOnly && <div className="col-md-1 col-xs-1 col-auto" style={{ minWidth:'25px', maxWidth:'25px', marginTop:'20px'}}>
        <input
            type="radio"
            aria-label="Choose price"
            name={"order-ticket-form-price-or-yield"}
            value={1}
            checked={priceOrYield===1}
            onChange={() => setPriceOrYield(1)}
            />
    </div>}

    <div className="col-md-1 col-xs-5 col-auto"
        style={{
            minWidth:'130px',
            ...(isReadOnly ? {paddingLeft:0}: {})
        }}
    >
        <div className="from-group" style={{ paddingLeft:'0px', paddingRight:'0px' }} >
            <div><Flyout
                label="Price"
                labelAttrs={{htmlFor:id}}
                isLabel={true}
                html={PriceTooltip}
            /></div>
            <div className={err ? ' has-error' : ''}>

            {isReadOnly && <div className='input-group'>
                <label className="label text-bold">${fmt.price3N(isCounterDisallowed ? bestPrice : orderInfo.price)}</label>
                </div>}

            {!isReadOnly && <input
                type="number"
                ref={setPriceEl}
                id={id}
                className='form-control'
                value={price}
                min="0"
                step="any"
                disabled={isDisabled}
                aria-disabled={isDisabled}
                style={{paddingLeft:'20px'}}
                onChange={(e) =>{
                    setPrice(e.target.value || '')
                }}
                />}
            </div>
            { err && <label className="field-status has-error">{err}</label> }
        </div>
    </div>

    { hasOrderInfo && canTrade && priceLabel && !isReadOnly &&
    <div className="col-md-1 col-xs-5 col-auto" style={{ minWidth:'200px', marginTop:'20px'}}>
        <div css={displayInline}>{priceLabel} Price: </div>
        <span className="text-bold">${fmt.price3N(bestPrice)}</span>
    </div>}

    </div>
    </React.Fragment>
}

const PriceTooltip = `
    The price displayed on your bond order ticket is typically firm from the participating dealer.
    In some instances, a dealer may allow for limit pricing to be submitted with your order.
    In these instances where a dealer will evaluate limit prices, you may set the maximum or minimum price
    you’re willing to buy or sell a security with your order. Limit price orders may be rejected by the dealer.
    Please note, bond prices are usually expressed as a percentage of the bond’s face value, or par value
    (e.g. a bond with a par value of $1,000, quoted at a price of $99, will cost $990 per bond).
`



// WEBPACK FOOTER //
// ./src/order-ticket/form/price.js